"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _dob, _age;
Object.defineProperty(exports, "__esModule", { value: true });
exports.toOrdinal = exports.BabyAge = void 0;
const luxon_1 = require("luxon");
class BabyAge {
    constructor(birthYear, birthMonth, birthDay, currentData) {
        _dob.set(this, void 0);
        _age.set(this, void 0);
        __classPrivateFieldSet(this, _dob, luxon_1.DateTime.local(birthYear, birthMonth, birthDay));
        const now = currentData || luxon_1.DateTime.local();
        __classPrivateFieldSet(this, _age, luxon_1.Interval.fromDateTimes(__classPrivateFieldGet(this, _dob), now));
    }
    days(exact = false) {
        const exactDays = __classPrivateFieldGet(this, _age).toDuration('days').toObject().days;
        return exact ? exactDays : Math.floor(exactDays);
    }
    weeks(exact = false) {
        const exactWeeks = __classPrivateFieldGet(this, _age).toDuration('weeks').toObject().weeks;
        return exact ? exactWeeks : Math.floor(exactWeeks);
    }
    months(exact = false) {
        const exactMonths = __classPrivateFieldGet(this, _age).toDuration('months').toObject().months;
        return exact ? exactMonths : Math.floor(exactMonths);
    }
    years(exact = false) {
        const exactYears = __classPrivateFieldGet(this, _age).toDuration('years').toObject().years;
        return exact ? exactYears : Math.floor(exactYears);
    }
    yearsMonthsAndDays(exact = false) {
        const exactAge = __classPrivateFieldGet(this, _age).toDuration(['years', 'months', 'days']).toObject();
        return exact ? exactAge : {
            years: Math.floor(exactAge.years),
            months: Math.floor(exactAge.months),
            days: Math.floor(exactAge.days),
        };
    }
    weeksAndDays(exact = false) {
        const exactAge = __classPrivateFieldGet(this, _age).toDuration(['weeks', 'days']).toObject();
        return exact ? exactAge : {
            weeks: Math.floor(exactAge.weeks),
            days: Math.floor(exactAge.days),
        };
    }
    whenIsDayNumber(dayNumber) {
        return __classPrivateFieldGet(this, _dob).plus({ days: (dayNumber - 1) });
    }
}
exports.BabyAge = BabyAge;
_dob = new WeakMap(), _age = new WeakMap();
function toOrdinal(num) {
    if (num <= 10 || num >= 20) {
        const lastDigits = num % 10;
        if (lastDigits === 1) {
            return `${num}st`;
        }
        else if (lastDigits === 2) {
            return `${num}nd`;
        }
        else if (lastDigits === 3) {
            return `${num}rd`;
        }
    }
    // else:
    return `${num}th`;
}
exports.toOrdinal = toOrdinal;
//# sourceMappingURL=baby-age.js.map